<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="8")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              .dropdown-buttons
                ActionButton(:action="deleteType") Delete
          .field-value(slot="n1") DT{{item.entity.id}} {{item.id}}
          .field-value(slot="n1") {{item.entity.name}}
          .field-value(slot="n2") Description
          .field-value(slot="n2") {{item.entity.description}}
          .field-value(slot="n3") Attachment views
          .field-value(slot="n3") {{item.entity.attachment_views.join(' - ')}}
          .field-value(slot="n4") Number required
          .field-value(slot="n4") {{item.entity.has_number ? 'Yes' : 'No'}}
          .field-value(slot="n5") Emission required
          .field-value(slot="n5") {{item.entity.has_emission ? 'Yes' : 'No'}}
          .field-value(slot="n6") Expiry required
          .field-value(slot="n6") {{item.entity.has_expiry ? 'Yes' : 'No'}}
          .field-value(slot="n7") Issuer required
          .field-value(slot="n7") {{item.entity.has_issuer ? 'Yes' : 'No'}}
          .field-value(slot="n8") Country required
          .field-value(slot="n8") {{item.entity.has_country ? 'Yes' : 'No'}}
</template>
<script type="text/babel">
import CardN from 'components/structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import TocButtons from '../structure/ui/actions/TocButtons'
import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'
import DocumentTypeButtons from '../structure/ui/actions/DocumentTypeButtons'
import ActionButton from "../structure/ui/ActionButton.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import MaggieHelper from "../../maggieHelper";

export default {
  name: 'DocumentTypeFederation',
  components: {
    ActionButton,
    DocumentTypeButtons,
    TocTypeButtons,
    TocButtons,
    Dropdown,
    CardN,
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    deleteType() {
      return KeplerBackofficeSdk.federationEntities.select(this.item.id).delete(() => {
        MaggieHelper.notification("Configuration", "Document type deleted")
        this.$emit("itemUpdated")
      })
    }
  },
  computed: {},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// DocumentTypeFederation.vue?2a3dc630